/* eslint-disable no-console */
/**
 * 로깅 유틸리티
 *
 * - 개발 환경: 모든 로그 출력
 * - 프로덕션 환경: 모든 로그 억제
 */

const isDev = import.meta.env.DEV;

class Logger {
  /** isDev일 때만 콜백 실행 */
  private run(fn: () => void): void {
    if (isDev) fn();
  }

  /** 일반 로그 */
  log(message: string, ...args: unknown[]): void {
    this.run(() => console.log(message, ...args));
  }

  /** 디버그 로그 */
  debug(message: string, ...args: unknown[]): void {
    this.run(() => console.log(`[DEBUG] ${message}`, ...args));
  }

  /** 정보 로그 */
  info(message: string, ...args: unknown[]): void {
    this.run(() => console.info(`[INFO] ${message}`, ...args));
  }

  /** 경고 로그 */
  warn(message: string, ...args: unknown[]): void {
    this.run(() => console.warn(`[WARN] ${message}`, ...args));
  }

  /** 에러 로그 */
  error(message: string, ...args: unknown[]): void {
    this.run(() => console.error(`[ERROR] ${message}`, ...args));
  }

  /** 그룹 시작 */
  group(label: string): void {
    this.run(() => console.group(label));
  }

  /** 그룹 종료 */
  groupEnd(): void {
    this.run(() => console.groupEnd());
  }

  /** 테이블 출력 */
  table(data: unknown): void {
    this.run(() => console.table(data));
  }
}

export const logger = new Logger();
